import {
  EditIcon,
  // RefreshIcon,
  TrashIcon,
} from 'Asset/icon';
import ButtonOutline from 'UiKit/button/buttonOutline';
import { Flex } from '@chakra-ui/react';

import { getMenuPermissions } from 'Helper/getMenuPermissions';
import { Condition } from 'Component/others';
// import usePostShopeeGenerateLink from 'Domain/shopee/usePostShopeeGenerateLink';

import useOpenDeleteModal from 'View/live-account/hooks/useOpenDeleteModal';
import { useLiveAccountState } from 'View/live-account/state';

const ActionButton = ({ values }) => {
  const accessPermission = getMenuPermissions('master-data', 'account-livestream');
  const { onOpenDeleteModal } = useOpenDeleteModal();
  const { updateState } = useLiveAccountState();
  // const { mutate: onPostShopeeGenerateLink } = usePostShopeeGenerateLink();

  return (
    <Flex gap="10px">
      <Condition statement={accessPermission?.isCanEdit}>
        <ButtonOutline
          borderWidth="1.5px"
          width="34px"
          height="34px"
          onClick={() => updateState({ selectedAccount: values, isOpenFormUpsert: true })}
          data-testid={`live-account-edit-${values.id}`}
        >
          <EditIcon color="var(--color-semantic-text)" />
        </ButtonOutline>
      </Condition>

      <Condition statement={accessPermission?.isCanDelete}>
        <ButtonOutline
          data-testid={`live-account-delete-${values.id}`}
          borderWidth="1.5px"
          color="var(--color-error50)"
          width="34px"
          height="34px"
          onClick={() => onOpenDeleteModal(values?.id)}
        >
          <TrashIcon color="var(--color-error50)" />
        </ButtonOutline>
      </Condition>
    </Flex>
  );
};

export default ActionButton;
